import PropTypes from 'prop-types'
import { FilterType, Order } from './enums'

export const tableAndTableTabCommonPropTypes = {
  title: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      filterType: PropTypes.oneOf(Object.values(FilterType)).isRequired,
      filterName: PropTypes.string,
      filterNames: PropTypes.arrayOf(PropTypes.string),
      filterPlaceholders: PropTypes.arrayOf(PropTypes.string),
      renderFunc: PropTypes.func,
      sortable: PropTypes.bool,
      isHiddenByDefault: PropTypes.bool,
      filterInputProps: PropTypes.object,
      selectOptions: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string.isRequired,
          value: PropTypes.string.isRequired
        })
      ),
      statusToIndicatorColorMap: PropTypes.object,
      dateDiffIndicator: PropTypes.bool
    })
  ).isRequired,
  fetchData: PropTypes.func.isRequired,
  addButton: PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    isClickable: PropTypes.bool,
    tooltip: PropTypes.string
  }),
  selection: PropTypes.shape({
    selectedRowsIds: PropTypes.arrayOf(PropTypes.string).isRequired,
    onRowsSelect: PropTypes.func.isRequired,
    onRowsRemove: PropTypes.func.isRequired
  }),
  onRowClick: PropTypes.func,
  renderToolbarLeftPanel: PropTypes.func,
  sort: PropTypes.shape({
    defaultSortParameters: PropTypes.arrayOf(
      PropTypes.shape({
        param: PropTypes.string.isRequired,
        order: PropTypes.oneOf(Object.values(Order)).isRequired
      })
    ),
    columnsGroupedBy: PropTypes.arrayOf(PropTypes.string)
  }),
  backgroundRefresh: PropTypes.shape({
    shouldHighlightRow: PropTypes.func
  }),
  hiddenFilters: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number])
  })),
  menu: PropTypes.shape({
    edit: PropTypes.shape({
      onClick: PropTypes.func.isRequired,
      isEditable: PropTypes.func
    }),
    copy: PropTypes.shape({
      onClick: PropTypes.func.isRequired,
      isCopyable: PropTypes.func
    }),
    delete: PropTypes.shape({
      onDelete: PropTypes.func.isRequired,
      onDeleteError: PropTypes.func,
      isDeletable: PropTypes.func,
      deleteDialog: PropTypes.shape({
        content: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired
      })
    })
  })
}

export const tablePropTypes = {
  tableKey: PropTypes.string.isRequired
}

export const tableTabPropTypes = {
  tabKey: PropTypes.string.isRequired,
  onPageResponseChange: PropTypes.func.isRequired,
  pageResponse: PropTypes.shape({
    number: PropTypes.number,
    size: PropTypes.number,
    totalItemCount: PropTypes.number,
    totalPageCount: PropTypes.number,
    items: PropTypes.arrayOf(PropTypes.object)
  }),
  tabId: PropTypes.string.isRequired,
  tableRef: PropTypes.object.isRequired,
}